import { render, staticRenderFns } from "./dataTemplateManager.vue?vue&type=template&id=98ba464c&scoped=true"
import script from "./dataTemplateManager.vue?vue&type=script&lang=js"
export * from "./dataTemplateManager.vue?vue&type=script&lang=js"
import style0 from "./dataTemplateManager.vue?vue&type=style&index=0&id=98ba464c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba464c",
  null
  
)

export default component.exports